import {
  dimensiondata_1_tetelek_group_w200_row,
  dimensiondata_2_termekek_1_2_group_dimension_column,
  kilo_tonna_value_1_data_precision,
  year_column_expanded,
  month_column,
  order_1,
  order_2
} from '../../fields';
import { PivotGridConfig } from '../../utils/pivot-grid-config';

export const haviSzenMerlegConfig: PivotGridConfig = {
  showChart: false,
  treeHeaderLayout: false,
  filterYear: {},
  options: {
    store: {
      version: 4,
      type: 'odata',
      url: 'odata/v4/public/HaviSzenMerleg',
      select: ['date', 'dimension_1', 'value_1'],
      beforeSend: (e: any) => {
        e.headers = {
          Accept: 'application/json;odata.metadata=none',
        };
      },
    },
    retrieveFields: false,
    fields: [
      ...dimensiondata_1_tetelek_group_w200_row,
      year_column_expanded,
      month_column,
      ...dimensiondata_2_termekek_1_2_group_dimension_column,
//      ezer_tonna_value_2_data_precision,
      kilo_tonna_value_1_data_precision,
//      terajoule_value_1_data_precision,
      order_1,
      order_2
    ],
  },
};
